var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcongalleryActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6756 0H5.33333C1.92889 0 0 1.92889 0 5.33333V14.6667C0 18.0711 1.92889 20 5.33333 20H14.6756C18.08 20 20 18.0711 20 14.6667V5.33333C20 1.92889 18.08 0 14.6756 0Z",
    fill: "#FAAA52"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2613_1437",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6756 0H5.33333C1.92889 0 0 1.92889 0 5.33333V14.6667C0 18.0711 1.92889 20 5.33333 20H14.6756C18.08 20 20 18.0711 20 14.6667V5.33333C20 1.92889 18.08 0 14.6756 0Z",
    fill: "#FAAA52"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2613_1437)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -5,
    width: 35,
    height: 20,
    fill: "#FAAA52"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 5,
    width: 11,
    height: 10,
    fill: "#FFEFDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5304 4H4.47033C3.65942 4 3 4.64913 3 5.44858V14.553C3 15.3516 3.65942 16 4.47033 16H14.5304C15.3413 16 16 15.3516 16 14.553V5.44858C16 4.64913 15.3413 4 14.5304 4ZM11.4065 6.15432C12.1907 6.15432 12.8266 6.78061 12.8266 7.55276C12.8266 8.32492 12.1906 8.95121 11.4065 8.95121C10.6221 8.95121 9.98633 8.32492 9.98633 7.55276C9.98633 6.78061 10.6221 6.15432 11.4065 6.15432ZM14.0693 14.6616H9.49989H5.13406C4.74184 14.6616 4.56716 14.3822 4.74397 14.0374L7.18122 9.28383C7.35782 8.93912 7.69439 8.90836 7.93273 9.21505L10.3835 12.3688C10.6218 12.6756 11.0384 12.7017 11.3141 12.4268L11.9137 11.829C12.1892 11.5542 12.5951 11.5882 12.82 11.9045L14.3725 14.0882C14.5969 14.405 14.4615 14.6616 14.0693 14.6616Z",
    fill: "#FAAA52"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcongalleryActive);
export default __webpack_public_path__ + "static/media/Icon.galleryActive.1a8d9465b353d14f92afd7a5adae82da.svg";
export { ForwardRef as ReactComponent };